/**
 * Record 의 키에서 *비어있지 않은 string* 만 안전하게 추출.
 *
 * - record 자체가 null / undefined → undefined
 * - 키가 존재하지 않거나 값이 string 이 아님 → undefined
 * - 값이 빈 문자열 (`''`) → undefined (의미 있는 값만 통과)
 *
 * 사용처: API 응답의 `Record<string, unknown>` 필드 (serverLogMeta 등) 또는
 * 도메인 매핑 단계에서의 안전 접근.
 */
export function readStringField(record: Record<string, unknown> | null | undefined, key: string): string | undefined {
  const value = record?.[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}
